/**
 * ? @description : Modal Component for view teacher details in spoc
 */

// Dependencies
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../../../axios/Axios"; 

// Redux Component
import { showSnackbar } from "../../../../../redux/features/appSlice";
import { Box, Dialog, DialogContent, DialogContentText, IconButton, Modal, Tab, Tabs, Tooltip, Typography } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Close, ContentCopy } from "@mui/icons-material";
import axios from "axios";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: "800px",
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};


function TeacherModal(props) {
  // * Redux
  const dispatch = useDispatch();
// console.log(props);
  // * State Variable
  const [teacher, setTeacher] = useState([]);
  const [tabValue, setTabValue] = useState("1");
  const [studentLevelInfo, setStudentLevelInfo] = useState([]);
  const [editedTeacherData, setEditedTeacherData] = useState({
    teacher_name: "",
    email: "",
    contactno: "",
    spoke_lang_1: "",
    spoke_lang_2: "",
    spoke_lang_3: "",
    spoke_lang_4: "",
    spoke_lang_5: "",
    spoke_lang_6: "",
    tentative_start_date: "",
    teacher_status: "",
    is_apr_residing: "",
    apr_homeaddress: "",
    apr_reference_name: "",
    apr_reference_contact: "",
    // parent_contactno: "",
    // address: "",
    // pincode: "",
    // city: "",
    // country: "",
  });
  
  // * Data Initialization
  var id = props.tabledata[1];

  // * Function Call
  useEffect(() => {
    // ? Get Method : Fetch Data From Server
    const controller = axios.CancelToken.source();
    (async () => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `/teacher/${id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };

          let response = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
          );

          if (response.status === 200) {
            setTeacher(response.data);
          }
        } catch (error) {
          if(!axios.isCancel(error)) {
            dispatch(
              showSnackbar({
                message: "Unable to get teacher information.",
                severity: "error",
              })
            );
          }
         
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [id, dispatch]);

  // * Assign Teacher Data to State Variable ( editedTeacherData )
  useEffect(() => {
    if (teacher.length > 0) {
      setEditedTeacherData(prev => ({
        ...prev,
        teacher_name: teacher[0].teacher_name,
        email: teacher[0].email,
        contactno: teacher[0].contactno,
        spoke_lang_1: teacher[0].spoke_lang_1,
        spoke_lang_2: teacher[0].spoke_lang_2,
        spoke_lang_3: teacher[0].spoke_lang_3,
        spoke_lang_4: teacher[0].spoke_lang_4,
        spoke_lang_5: teacher[0].spoke_lang_5,
        spoke_lang_6: teacher[0].spoke_lang_6,
        tentative_start_date: teacher[0].tentative_start_date,
        teacher_status: teacher[0].teacher_status,
        is_apr_residing: teacher[0].is_apr_residing,
        apr_homeaddress: teacher[0].apr_homeaddress,
        apr_reference_name: teacher[0].apr_reference_name,
        apr_reference_contact: teacher[0].apr_reference_contact,
      }));
    }
  }, [teacher]);


  useEffect(() => {
    const controller = axios.CancelToken.source();
    (async() => {
      if (id !== undefined) {
        try {
          let options = {
            method: "GET",
            url: `teacher/get/mapped_student_level_details/${id}`,
            auth: true,
            data: null,
            token:{cancelToken: controller.token}
          };
  
          let {data} = await Axios(
            options.method,
            options.url,
            options.auth,
            options.data,
            options.token,
          );
          
          if(typeof data.result_status1 === "object"){
            let studentStatus = data.result_status1.map(result => {
              let index = data.result_status2.findIndex(find => find.level_id === result.current_level_id);
              return {
                ...result,
                level_name: index !== -1 ? data.result_status2[index].level_name : "Not assigned"
              }
            });
            setStudentLevelInfo(studentStatus);
          }else{
            setStudentLevelInfo([]);
          }
          
        } catch (error) {
          if(!axios.isCancel(error)){
            console.log(error);
          }
          // dispatch(
          //   showSnackbar({
          //     message: "Unable to get mapped to students information.",
          //     severity: "error",
          //   })
          // );
        }
      }
    })();
    return () => {
      controller.cancel();
  }
  },[id])
// console.log(studentLevelInfo);
  return (
    teacher.length > 0 && (
      <Modal
        open={props.show}
        onClose={props.onHide}
      >
        <Box sx={style}>
          <TabContext value={tabValue}>
                {/* Tab Headings */}
                <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: "row",  alignItems: "center", justifyContent: "space-between" }}>
                    <TabList
                      value={tabValue}
                      onChange={(e, newValue) => setTabValue(newValue)}
                    >
                      <Tab label="Primary" value="1" />
                      <Tab label="Languages" value="2" />
                      <Tab label="Group" value="3" />
                      <Tab label="Residence" value="4" />
                    </TabList>
                    <IconButton onClick={props.onHide}>
                      <Close/>
                    </IconButton>
                </Box>
                <TabPanel value="1">
                  <div className="d-flex justify-content-start">
                    <div>
                      <div style={{ display: "none", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Unique Id :</p>
                        <strong>{teacher[0].teacher_id}</strong>
                      </div>

                      {/* <br /> */}

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>
                          Name :
                        </p>
                        <strong>{editedTeacherData.teacher_name}</strong>
                      </div>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>
                          E-mail :
                        </p>
                        <strong>{editedTeacherData.email}</strong>
                        <Tooltip title="Copy">
                          <IconButton
                            sx={{ml: 1}}
                            size="small" 
                            onClick={() => {
                              navigator.clipboard.writeText(editedTeacherData.email);
                              dispatch(
                                showSnackbar({
                                  message: "Text Copied!",
                                  severity: "success",
                                })
                              );
                            }}
                          >
                            <ContentCopy sx={{fontSize: 15}}/>
                          </IconButton>
                        </Tooltip>
                      </div>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>
                          Mobile :
                        </p>
                        <strong>{editedTeacherData.contactno}</strong>
                        <Tooltip title="Copy">
                          <IconButton
                            sx={{ml: 1}}
                            size="small" 
                            onClick={() => {
                              navigator.clipboard.writeText(editedTeacherData.contactno);
                              dispatch(
                                showSnackbar({
                                  message: "Number Copied!",
                                  severity: "success",
                                })
                              );
                            }}
                          >
                            <ContentCopy sx={{fontSize: 15}}/>
                          </IconButton>
                        </Tooltip>
                      </div>
                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Registered Date :</p>
                        <strong>{teacher[0].tcreated_at.split("T")[0]}</strong>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value="2">
                    <div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>
                          Language 1 : 
                        </p>
                        <strong>{editedTeacherData.spoke_lang_1}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Language 2 :</p>
                        <strong>{editedTeacherData.spoke_lang_2 === null ? "-" : editedTeacherData.spoke_lang_2}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Language 3 :</p>
                        <strong>{editedTeacherData.spoke_lang_3 === null ? "-" : editedTeacherData.spoke_lang_3}</strong>

                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Language 4 :</p>
                        <strong>{editedTeacherData.spoke_lang_4 === null ? "-" : editedTeacherData.spoke_lang_4}</strong>

                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Language 5 :</p>
                        <strong>{editedTeacherData.spoke_lang_5 === null ? "-" : editedTeacherData.spoke_lang_5}</strong>
                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>Language 6 :</p>
                        <strong>{editedTeacherData.spoke_lang_6 === null ? "-" : editedTeacherData.spoke_lang_6}</strong>
                      </div>
                    </div>
                </TabPanel>
                <TabPanel value="3">
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-row justify-content-start pt-3 pb-3">
                      <div style={{ display: "none",width: "280px", gap: "10px" }}>
                          <p>Batch Id :</p>
                        <strong>{teacher[0].group_id}</strong>
                      </div>

                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>Batch Name :</p>
                        <strong>{teacher[0].group_name}</strong>
                      </div>

                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>Role :</p>
                        <strong>{teacher[0].role}</strong>
                      </div>

                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>Comments :</p>
                        <strong>{teacher[0].note_description === null ?  "-" : teacher[0].note_description}</strong>
                      </div>

                    </div>

                    <div className="d-flex flex-row justify-content-start pt-3 pb-3">
                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>
                          Status :
                        </p>
                        <strong>{editedTeacherData.teacher_status}</strong>
                      </div>

                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>Group Status :</p>
                        <strong>{teacher[0].group_status}</strong>
                      </div>

                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>Mapped Status :</p>
                        <strong>{teacher[0].teacher_mapped_status}</strong>
                      </div>

                      <div style={{ display: "flex", width: "280px", gap: "20px"}}>
                        <p>Audio Status :</p>
                        <strong>{teacher[0].audio_status}</strong>
                      </div>
                    </div>

                  </div>
                </TabPanel>
                <TabPanel value="4">
                    <div>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>
                        Residing in APR: 
                        </p>
                        <strong> {teacher[0].is_apr_residing === true ? "Yes" : "No"}</strong>
                      </div>

                      <br />

                      {/* <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>APR Home Address :</p>
                        <strong>{teacher[0].apr_homeaddress}</strong>
                      </div>

                      <br /> */}

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "150px" }}>APR Reference Name :</p>
                        <strong>{teacher[0].apr_reference_name}</strong>

                      </div>

                      <br />

                      <div style={{ display: "flex", alignItems: "center" }}>
                        <p style={{ width: "180px" }}>APR Reference Contact :</p>
                        <strong>{teacher[0].apr_reference_contact}</strong>
                      </div>
                    </div>
                </TabPanel>
          </TabContext>
        </Box>
      </Modal>






      // <Dialog
      //     open={props.open}
      //     onClose={props.onClose}
      //     maxWidth="lg"
      //     fullWidth
      //     aria-labelledby="dialog-title"
      //     aria-describedby="dialog-content"
      //   > 
      //     <DialogContent>
      //       <DialogContentText id="dialog-content">
      //         <Box>
      //           <TabContext value={tabValue}>
      //             {/* Tab Headings */}
      //             <Box sx={{ borderBottom: 1, borderColor: "divider", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
      //               <TabList
      //                 aria-label="Tabs Header"
      //                 onChange={(e, newValue) => {
      //                   e.preventDefault();
      //                   setTabValue(newValue);
      //                 }}
      //               >
      //                 <Tab label="Primary" value={1} />
      //                 <Tab label="Languages" value={2} />
      //                 <Tab label="Batch" value={3} />
      //                 <Tab label="Adarsh Palm Retreat" value={4} />
      //               </TabList>
      //               <IconButton onClick={() => props.onClose()}>
      //                 <Close/>
      //               </IconButton>
      //             </Box>

      //             {/* Tab Panels */}
      //             <TabPanel value={1}>
      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Unique Id
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].teacher_id}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Teacher Name
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].teacher_name}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Email
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].email}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Phone Number
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].contactno}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Tentative Start Date
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].tentative_start_date.split("T")[0]}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Registered Date
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].tcreated_at.split("T")[0]}
      //                 </Typography>
      //               </Box>
      //             </TabPanel>

      //             <TabPanel value={2}>
      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Language 1
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].spoke_lang_1}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Language 2
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].spoke_lang_2}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Language 3
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].spoke_lang_3}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Language 4
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].spoke_lang_4}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Language 5
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].spoke_lang_5}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Language 6
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].spoke_lang_6}
      //                 </Typography>
      //               </Box>
      //             </TabPanel>

      //             <TabPanel value={3}>
      //               <Box
      //                 sx={{
      //                   display: "flex",
      //                   flexDirection: "row",
      //                 }}
      //               >
      //                 <Box sx={{ mr: "100px" }}>
      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 250 }}
      //                     >
      //                       Batch Id
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].group_id}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 250 }}
      //                     >
      //                       Batch Name
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].group_name}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 250 }}
      //                     >
      //                       Group Status
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].group_status}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 250 }}
      //                     >
      //                       Teacher Mapped Status
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].teacher_mapped_status}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 250 }}
      //                     >
      //                       Teacher Mapped To
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].mapped_to_student}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 250 }}
      //                     >
      //                       Audio Status
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].audio_status}
      //                     </Typography>
      //                   </Box>
      //                 </Box>

      //                 <Box>
      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 200 }}
      //                     >
      //                       Teacher Status
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].teacher_status}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 200 }}
      //                     >
      //                       Role
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].role}
      //                     </Typography>
      //                   </Box>

      //                   <Box sx={{ display: "flex", alignItems: "center" }}>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ width: 200 }}
      //                     >
      //                       Comments
      //                     </Typography>
      //                     <Typography
      //                       variant="p"
      //                       component="div"
      //                       sx={{ color: "#1d3faa" }}
      //                     >
      //                       {TeacherData[0].note_description}
      //                     </Typography>
      //                   </Box>
      //                 </Box>
      //               </Box>
      //             </TabPanel>

      //             <TabPanel value={4}>
      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   Residing in APR
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].is_apr_residing === true ? "Yes" : "No"}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   APR Home Address
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].apr_homeaddress}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   APR Reference Name
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].apr_reference_name}
      //                 </Typography>
      //               </Box>

      //               <Box sx={{ display: "flex", alignItems: "center" }}>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ width: 200 }}
      //                 >
      //                   APR Reference Contact
      //                 </Typography>
      //                 <Typography
      //                   variant="p"
      //                   component="div"
      //                   sx={{ color: "#1d3faa" }}
      //                 >
      //                   {TeacherData[0].apr_reference_contact}
      //                 </Typography>
      //               </Box>
      //             </TabPanel>
      //           </TabContext>
      //         </Box>
      //       </DialogContentText>
      //     </DialogContent>
      //   </Dialog>
    )
  );
}

export default TeacherModal;
